import { useRef, useEffect } from 'react'

/**
 * this hook will return true if the component is running through its first render and effect cycle
 */
export const useIsFirstRender = () => {
  const isFirstRender = useRef(true)
  useEffect(() => {
    isFirstRender.current = false
  }, [])

  return isFirstRender.current
}
